import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const WebsiteFooter = () => {
  return (
    <footer className="bg-slate-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.jpg" alt="BBH" className="h-12 rounded bg-white p-1" />
              <div>
                <p className="font-bold text-white">BOSVELD BOU</p>
                <p className="text-xs text-blue-400">& HARDEWARE</p>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              Your trusted hardware partner in Tom Burke. Quality building materials, tools, and supplies for all your construction and DIY needs.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/site" className="hover:text-blue-400 transition-colors">Home</Link></li>
              <li><Link to="/site/products" className="hover:text-blue-400 transition-colors">Products</Link></li>
              <li><Link to="/site/promotions" className="hover:text-blue-400 transition-colors">Specials</Link></li>
              <li><Link to="/site/about" className="hover:text-blue-400 transition-colors">About Us</Link></li>
              <li><Link to="/site/contact" className="hover:text-blue-400 transition-colors">Contact</Link></li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-white mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-blue-400 mt-0.5 flex-shrink-0" />
                <span>R572, Farm Van Wyksfontein,<br />Tom Burke, 0621</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-blue-400 flex-shrink-0" />
                <a href="tel:0832785937" className="hover:text-blue-400">083 278 5937</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-blue-400 flex-shrink-0" />
                <a href="mailto:bosveldbh@gmail.com" className="hover:text-blue-400">bosveldbh@gmail.com</a>
              </li>
            </ul>
          </div>
          
          {/* Store Hours */}
          <div>
            <h3 className="font-semibold text-white mb-4">Store Hours</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-blue-400 flex-shrink-0" />
                <div>
                  <p className="font-medium text-white">Monday - Saturday</p>
                  <p>07:30 - 18:00</p>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-red-400 flex-shrink-0" />
                <div>
                  <p className="font-medium text-white">Sunday</p>
                  <p>Closed</p>
                </div>
              </li>
            </ul>
            
            {/* WhatsApp */}
            <a 
              href="https://wa.me/27832785937" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm transition-colors"
            >
              <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              WhatsApp Us
            </a>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-sm text-gray-500">
          <p>© {new Date().getFullYear()} BOSVELD BOU & HARDEWARE. All rights reserved.</p>
          <p className="mt-1">
            <Link to="/site" className="hover:text-blue-400">bosveldbh.co.za</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default WebsiteFooter;
